<template>
  <div class="space-y-4">
    <!-- Toolbar: search + add -->
    <div
      class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
    >
      <div class="relative w-full max-w-sm">
        <span
          class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
        >
          <span class="text-base text-gray-500 material-icons-round"
            >search</span
          >
        </span>
        <input
          @keyup="search"
          class="w-full h-10 pl-9 pr-3 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
          placeholder="Search users..."
        />
      </div>

      <button
        @click="changePage('add')"
        class="inline-flex items-center justify-center h-10 px-4 text-sm font-semibold text-white transition-colors rounded-xl shadow-sm bg-taxiye-500 hover:bg-taxiye-600"
      >
        <span class="mr-1 text-base material-icons-round">person_add</span>
        Add User
      </button>
    </div>

    <!-- Table -->
    <div
      class="overflow-hidden bg-white border border-gray-200 shadow-sm rounded-2xl"
    >
      <div class="overflow-x-auto">
        <table class="min-w-full">
          <thead>
            <tr>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                ID
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Full name
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Email
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Roles
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Status
              </th>
              <th class="px-5 py-3 border-b border-gray-200 bg-gray-50"></th>
            </tr>
          </thead>
          <tbody class="relative" v-if="accounts.data && accounts.data.length">
            <tr
              v-for="(account, index) in accounts.data"
              :key="index"
              class="transition-colors hover:bg-gray-50"
            >
              <td
                class="px-5 py-4 text-sm text-gray-500 border-b border-gray-100"
              >
                <p class="whitespace-no-wrap">{{ account._id }}</p>
              </td>
              <td
                class="px-5 py-4 text-sm text-gray-800 border-b border-gray-100"
              >
                <p class="font-medium whitespace-no-wrap">
                  {{ account.firstName + " " + account.lastName }}
                </p>
              </td>
              <td
                class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100"
              >
                <p class="whitespace-no-wrap">
                  {{ account.email }}
                </p>
              </td>
              <td
                class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100"
              >
                <span
                  class="inline-block px-2.5 py-1 mb-1 mr-1.5 text-xs font-medium rounded-full text-taxiye-700 bg-taxiye-100"
                  v-for="role in account.corporateRoles"
                  :key="role._id"
                >
                  {{ role.roleName }}</span
                >
              </td>
              <td
                class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100"
              >
                <span
                  class="inline-flex px-2.5 py-1 text-xs font-medium text-green-700 rounded-full bg-green-100"
                  v-if="account.active"
                >
                  Active</span
                >
                <span
                  class="inline-flex px-2.5 py-1 text-xs font-medium text-red-700 rounded-full bg-red-100"
                  v-else
                >
                  Inactive</span
                >
              </td>
              <td
                class="px-5 py-4 text-sm text-right text-gray-700 border-b border-gray-100"
              >
                <div @click.stop class="relative inline-block text-left">
                  <div>
                    <span class="rounded-md">
                      <button
                        @click="toggleDropdown(index)"
                        type="button"
                        class="inline-flex items-center justify-center w-8 h-8 text-gray-500 transition-colors rounded-lg hover:bg-gray-100 hover:text-gray-700 focus:outline-none"
                        aria-haspopup="true"
                        :aria-expanded="openDropdown === index"
                        :ref="
                          openDropdown === index
                            ? 'accounts-dropdown-trigger-' + ref
                            : ''
                        "
                      >
                        <span class="material-icons-round">more_vert</span>
                      </button>
                    </span>
                  </div>
                  <transition
                    enter-active-class="transition duration-100 ease-out"
                    enter-class="transform scale-95 opacity-0"
                    enter-to-class="transform scale-100 opacity-100"
                    leave-active-class="transition duration-75 ease-in"
                    leave-class="transform scale-100 opacity-100"
                    leave-to-class="transform scale-95 opacity-0"
                  >
                    <div
                      v-if="openDropdown === index"
                      class="absolute right-0 z-10 w-56 mt-1 origin-top-right bg-white border border-gray-200 shadow-lg rounded-xl"
                      :ref="
                        openDropdown === index ? 'accounts-dropdown-' + ref : ''
                      "
                    >
                      <div
                        class="py-1"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                      >
                        <p
                          @click="edit(account._id)"
                          class="flex items-center px-4 py-2 space-x-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-50 hover:text-gray-900 focus:outline-none"
                          role="menuitem"
                        >
                          <span class="text-base material-icons-round"
                            >edit</span
                          >
                          <span>Edit</span>
                        </p>
                        <p
                          @click="resetPassword(account._id)"
                          class="flex items-center px-4 py-2 space-x-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-50 hover:text-gray-900 focus:outline-none"
                          role="menuitem"
                        >
                          <span class="text-base material-icons-round"
                            >vpn_key</span
                          >
                          <span>Reset Password</span>
                        </p>
                        <button
                          @click="toggleActive(account._id)"
                          type="button"
                          class="flex items-center w-full px-4 py-2 space-x-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 focus:outline-none"
                          role="menuitem"
                        >
                          <span
                            v-if="account.active"
                            class="text-base material-icons-round"
                            >close</span
                          >
                          <span v-else class="text-base material-icons-round"
                            >check</span
                          >
                          <span>
                            {{
                              account.active ? "Make Inactive" : "Make Active"
                            }}
                          </span>
                        </button>
                        <div class="my-1 border-t border-gray-100"></div>
                        <button
                          @click="openConfirmBox"
                          type="button"
                          class="flex items-center w-full px-4 py-2 space-x-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-700 focus:outline-none"
                          role="menuitem"
                        >
                          <span class="text-base material-icons-round"
                            >delete</span
                          >
                          <span>Delete</span>
                          <portal to="modals">
                            <transition
                              enter-active-class="transition duration-100 ease-out"
                              enter-class="transform scale-95 opacity-0"
                              enter-to-class="transform scale-100 opacity-100"
                              leave-active-class="transition duration-75 ease-in"
                              leave-class="transform scale-100 opacity-100"
                              leave-to-class="transform scale-95 opacity-0"
                            >
                              <div
                                v-if="confirmOpen"
                                @click="closeConfirmBox"
                                class="absolute inset-0 z-40 flex items-center justify-center bg-black bg-opacity-25"
                              >
                                <div
                                  @click.stop
                                  class="w-full max-w-lg overflow-hidden bg-white shadow-lg rounded-2xl"
                                >
                                  <div
                                    class="px-6 py-4 border-b border-gray-200 bg-gray-50"
                                  >
                                    <h3 class="font-semibold text-gray-800">
                                      Confirm Delete
                                    </h3>
                                  </div>
                                  <div
                                    class="flex items-center px-6 py-6 space-x-4"
                                  >
                                    <span
                                      class="text-4xl text-red-500 material-icons-round"
                                      >warning</span
                                    >
                                    <div>
                                      <p class="text-gray-700">
                                        Are you sure you want to delete this
                                        account?
                                      </p>
                                      <p>
                                        <em class="text-sm text-gray-500"
                                          >This action can not be undone!</em
                                        >
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    class="flex items-center justify-between px-6 py-4 border-t border-gray-200"
                                  >
                                    <button
                                      @click="closeConfirmBox"
                                      type="button"
                                      class="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      @click="deleteAccount(account._id)"
                                      type="button"
                                      :disabled="deleting"
                                      class="inline-flex items-center h-10 px-4 space-x-2 text-sm font-semibold rounded-xl shadow-sm"
                                      :class="
                                        deleting
                                          ? 'bg-red-100 text-red-400 cursor-not-allowed'
                                          : 'bg-red-500 text-white hover:bg-red-600'
                                      "
                                    >
                                      <span
                                        v-if="deleting"
                                        class="text-base material-icons-round spin"
                                        >sync</span
                                      >
                                      <span
                                        v-else
                                        class="text-base material-icons-round"
                                        >delete</span
                                      >
                                      <span>Delete</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </transition>
                          </portal>
                        </button>
                      </div>
                    </div>
                  </transition>
                </div>
              </td>
            </tr>
            <div
              v-if="loading"
              class="absolute inset-0 flex items-center justify-center w-full h-full bg-white bg-opacity-60"
            >
              <span class="text-5xl material-icons-round spin text-taxiye-500"
                >sync</span
              >
              <span class="invisible block">Loading...</span>
            </div>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7" class="px-5 py-12 text-center bg-white">
                <div
                  v-if="loading"
                  class="inline-flex flex-col items-center text-gray-400"
                >
                  <span class="text-5xl material-icons-round spin">sync</span>
                  <span class="mt-2 text-sm">Loading...</span>
                </div>
                <div
                  v-else
                  class="inline-flex flex-col items-center text-gray-400"
                >
                  <span class="text-5xl material-icons-round">group_off</span>
                  <span class="mt-2 text-sm font-medium">No user found!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="flex items-end justify-between">
      <pagination
        class="flex space-x-2"
        :currentPage="currentPage"
        :total="total"
        @goto="goToPage"
        @setPerPage="setPerPage"
        :perPage="perPage"
        :start="start"
        :end="end"
        :count="paginator.count"
      ></pagination>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PaginationMixin from "@/mixins/Pagination";
import Pagination from "@/components/Pagination";
// import { ROLES } from "@/config";

export default {
  mixins: [PaginationMixin],
  props: ["corporate", "changePage"],
  data() {
    return {
      accounts: [],
      openDropdown: false,
      perPage: 10,
      searchKey: "",
      loading: true,
      confirmOpen: false,
      deleting: false,
      ref: "",
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.getAccounts();
    this.ref = Math.random()
      .toString(36)
      .substr(2, 5);
  },
  watch: {
    currentPage() {
      this.getAccounts();
    },
    corporate() {
      this.getAccounts();
    },
    openDropdown(newVal) {
      if (newVal !== false) {
        document.body.addEventListener("click", this.clickAwayHandler);
      } else {
        document.body.removeEventListener("click", this.clickAwayHandler);
      }
    },
  },
  computed: {},
  methods: {
    // roleName(id) {
    //   return ROLES.resolveName(id);
    // },
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    },
    getAccounts() {
      this.loading = true;
      var path =
        'accounts?populate=["corporate"]&page=' +
        this.currentPage +
        "limit=" +
        this.perPage +
        "&corporate=" +
        this.corporate._id;

      if (this.searchKey) {
        path += "&q=" + this.searchKey;
      }
      this.$misc
        .get(path)
        .then(response => {
          this.accounts = response.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count,
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    openConfirmBox() {
      this.confirmOpen = true;
    },
    closeConfirmBox() {
      this.confirmOpen = false;
    },
    deleteAccount(id) {
      this.deleting = true;
      this.$misc
        .delete(`accounts/${id}`)
        .then(result => {
          window.flash({
            type: "success",
            body: "User was deleted successfully!",
          });
          this.getAccounts();
          console.log(result);
        })
        .catch(err => {
          window.flash({
            type: "error",
            body: "Failed to delete the user!",
          });
          console.log(err);
        })
        .finally(() => {
          this.deleting = false;
          this.confirmOpen = false;
          this.openDropdown = false;
          this.getAccounts();
        });
    },
    search: _.debounce(function(e) {
      this.searchKey = e.target.value.trim();
      this.getAccounts();
    }, 500),
    toggleActive(id) {
      const currentStatus = this.accounts.data.find(
        account => account._id === id
      ).active;
      this.$misc
        .patch(`/accounts/${id}`, {
          active: !currentStatus,
        })
        .then(() => {
          window.flash({
            type: "success",
            body: currentStatus
              ? "User is now Inactive!"
              : "User is now Active!",
          });
          this.getAccounts();
        })
        .catch(err => {
          window.flash({
            type: "error",
            body: "Failed to update user status!",
          });
          console.log(err);
        })
        .finally(() => (this.openDropdown = false));
    },
    edit(id) {
      var account = this.accounts.data.find(account => account._id === id);
      this.changePage("edit", account);
    },
    resetPassword(id) {
      var account = this.accounts.data.find(account => account._id === id);
      this.changePage("reset-password", account);
    },
    clickAwayHandler(e) {
      if (
        (this.$refs["accounts-dropdown-trigger-" + this.ref] &&
          this.$refs["accounts-dropdown-trigger-" + this.ref][0].contains(
            e.target
          )) ||
        this.$refs["accounts-dropdown-" + this.ref] === e.target
      ) {
        return;
      }

      this.openDropdown = false;
    },
  },
};
</script>
